var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSupport(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1427_3427)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.92407 15.0187C6.00278 15.0974 6.13228 15.0974 6.21099 15.0187L8.79575 12.4339L10.9819 14.6226C11.0606 14.7013 11.1901 14.7013 11.2688 14.6226L17.0147 8.87163C17.0934 8.79292 17.0934 8.66343 17.0147 8.58472L16.0803 7.65034C16.0016 7.57163 15.8721 7.57163 15.7934 7.65034L11.1266 12.3222L8.94048 10.1335C8.86177 10.0548 8.73228 10.0548 8.65356 10.1335L4.9897 13.7974C4.91099 13.8761 4.91099 14.0056 4.9897 14.0843L5.92407 15.0187Z",
    fill: "#FF9A00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M20.9531 4.0625H11.9141V2.4375C11.9141 2.32578 11.8227 2.23438 11.7109 2.23438H10.2891C10.1773 2.23438 10.0859 2.32578 10.0859 2.4375V4.0625H1.04688C0.597461 4.0625 0.234375 4.42559 0.234375 4.875V18.0781C0.234375 18.5275 0.597461 18.8906 1.04688 18.8906H10.0961V19.7031L5.91172 22.4479C5.81777 22.5088 5.79238 22.6332 5.85332 22.7271L6.62266 23.9256V23.9281C6.68359 24.0221 6.81055 24.0475 6.90449 23.9865L11 21.3002L15.0955 23.9865C15.1895 24.0475 15.3164 24.0221 15.3773 23.9281V23.9256L16.1467 22.7271C16.2076 22.6332 16.1797 22.5088 16.0883 22.4479L11.9141 19.7107V18.8906H20.9531C21.4025 18.8906 21.7656 18.5275 21.7656 18.0781V4.875C21.7656 4.42559 21.4025 4.0625 20.9531 4.0625ZM19.9375 17.0625H2.0625V5.89062H19.9375V17.0625Z",
    fill: "#FF9A00"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1427_3427"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 22,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSupport);
export default __webpack_public_path__ + "static/media/support.6c17f53bffa0c8e93b2c8cbabedbbb40.svg";
export { ForwardRef as ReactComponent };